import API from '@/services/api'

export default {
  async refundTransaction(transactionId) {
    const response = await API.post('/transaction/refund', { last_transaction_id: transactionId })
    if (response?.data?.success === false) {
      const error = new Error(response.data.error || 'Refund failed')
      error.response = response
      throw error
    }
    return response
  },
  async retryTransaction(previousTransactionId, cableType, paymentMethod) {
    return API.post('/transaction/validation/take_battery', {
      previous_transaction_id: previousTransactionId,
      transaction_id: previousTransactionId,
      cable_type: cableType,
      payment_method: paymentMethod,
      retry_take_battery: true
    })
  }
}
